import React, { useState } from 'react';
import { formatValue } from '../../utils/formatters';

const ManualActionsSection = ({ manualActions, onActionClick }) => {
    if (!manualActions || !manualActions.actions || !Array.isArray(manualActions.actions) || manualActions.actions.length === 0) {
        return null;
    }

    const actions = manualActions.actions;

    const getActionLabel = (actionType) => {
        if (!actionType) return 'Unknown Action';
        switch (actionType) {
            case 'add_contact':
                return 'Add Contact';
            default:
                return String(actionType).replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        }
    };

    const getActionIcon = (actionType) => {
        if (!actionType) return '⚙️';
        switch (actionType) {
            case 'add_contact':
                return '👤';
            default:
                return '⚙️';
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            return date.toLocaleString();
        } catch (e) {
            return dateString;
        }
    };

    return (
        <div style={{ marginBottom: '30px' }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '15px'
            }}>
                <h4 style={{ color: '#e0e0e0', fontWeight: '600', margin: 0 }}>Manual Actions Required</h4>
                <div style={{
                    backgroundColor: '#ef4444',
                    color: '#ffffff',
                    borderRadius: '999px',
                    padding: '4px 12px',
                    fontSize: '12px',
                    fontWeight: '600'
                }}>
                    {actions.length} {actions.length === 1 ? 'action' : 'actions'}
                </div>
            </div>
            <div style={{
                backgroundColor: '#2d2d2d',
                border: '1px solid #404040',
                borderRadius: '6px',
                padding: '20px'
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px'
                }}>
                    {actions.filter(action => action && action.action).map((action, index) => (
                        <div
                            key={index}
                            onClick={() => onActionClick && onActionClick(action)}
                            style={{
                                backgroundColor: '#181818',
                                border: '1px solid rgba(239, 68, 68, 0.3)',
                                borderRadius: '8px',
                                padding: '16px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#1f1f1f';
                                e.currentTarget.style.borderColor = 'rgba(239, 68, 68, 0.5)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#181818';
                                e.currentTarget.style.borderColor = 'rgba(239, 68, 68, 0.3)';
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                gap: '16px',
                                flexWrap: 'wrap'
                            }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        marginBottom: '8px'
                                    }}>
                                        <span style={{ fontSize: '20px' }}>
                                            {getActionIcon(action.action)}
                                        </span>
                                        <div style={{
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            color: '#e0e0e0'
                                        }}>
                                            {getActionLabel(action.action)}
                                        </div>
                                    </div>
                                    {action.reason && (
                                        <div style={{
                                            fontSize: '13px',
                                            color: '#a0a0a0',
                                            marginTop: '8px'
                                        }}>
                                            {formatValue(action.reason)}
                                        </div>
                                    )}
                                    {action.created_at && (
                                        <div style={{
                                            fontSize: '12px',
                                            color: '#707070',
                                            marginTop: '8px'
                                        }}>
                                            Created: {formatDate(action.created_at)}
                                        </div>
                                    )}
                                </div>
                                <div style={{
                                    backgroundColor: '#ef4444',
                                    color: '#ffffff',
                                    borderRadius: '6px',
                                    padding: '8px 16px',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    whiteSpace: 'nowrap'
                                }}>
                                    Perform Action →
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ManualActionsSection;

